import React from "react";
import "./Footer.css";

const Footer = () => (
    <footer class="page-footer">
    <div id="footer" class="footer-copyright">
      <div class="container">
          © 2018 Powered by <i class="fa fa-coffee" aria-hidden="true"></i> and <i class="fa fa-heart" aria-hidden="true"></i>
          <a class="white-text right" href="https://github.com/aidanclemente" target="_blank">   &nbsp; Aidan Clemente </a>
      </div>
    </div>
  </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js